export default "__VITE_ASSET__wnwbr9W3__"